import dayjs from 'dayjs'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { API_DATE_FORMAT } from 'interfaces/constants'
import {
  ACTIVITY_LEVEL_NAME,
  HealthToolGender,
} from 'interfaces/constants/healthTools'
import { UserInfo } from 'interfaces/types'

export type GENDER = 'male' | 'female'

export const formartGenderToSso = (data: GENDER) => (data === 'male' ? 1 : 0)
export const formartSSOGenderToHealthtoolForm = (data: number) =>
  data === 1 ? 'male' : 'female'

export const checkAndSaveUserInfo = async ({
  userInfo,
  data,
  forceSaveBirthday = false,
}: {
  userInfo: UserInfo
  data: {
    gender?: HealthToolGender
    birthday?: Date
    weight?: string
    height?: string
    activityLevel?: ACTIVITY_LEVEL_NAME
  }
  forceSaveBirthday?: boolean
}) => {
  try {
    await Promise.all([
      data.height ||
      data.weight ||
      data.activityLevel ||
      (userInfo?.birthday === null && data.birthday) ||
      forceSaveBirthday
        ? callApiNew(
            PATHS.SSO.UPDATE_HEALTH_TOOL,
            {
              method: 'POST',
              data: {
                ...(data.height && {
                  height: data.height,
                }),
                ...(data.weight && {
                  weight: data.weight,
                }),
                ...(data.activityLevel && {
                  activity_level: data.activityLevel,
                }),
                ...(((userInfo?.birthday === null && data?.birthday) ||
                  forceSaveBirthday) && {
                  birthday: dayjs(data.birthday).format(API_DATE_FORMAT),
                }),
              },
            },
            'sso',
          )
        : undefined,
      userInfo?.gender === -1 && data.gender
        ? callApiNew(
            PATHS.SSO.UPDATE_PROFILE,
            {
              method: 'POST',
              data: {
                gender: formartGenderToSso(data.gender),
              },
            },
            'sso',
          )
        : undefined,
    ])
  } catch (err) {
    console.log(err)
  }
}
